import { VALID_EMAIL, useRecoveryForm } from "@usher/pe-client-front-end-lib"
import { FormWrapper } from "@/Components/Form"
import { Input } from "@/Components/Form/Input"
import { Text } from "@/Components/Text"
import { Container } from "@/Layout/Container"
import { Paper } from "@/Layout/Paper"
import "./style.sass"
import { Button } from "@/Components/Control/Button"
import { Image } from "@/Components/common/Image"
import { Alert } from "react-bootstrap"

export const Recovery = () => {
  const { formMethods, onSubmit, email, loading } = useRecoveryForm()
  return (
    <div className="password__recovery">
      <Container>
        <div className="text-center">
          <Text variant="paperTitle">Password Recovery</Text>
        </div>

        {email && (
          <Alert variant="success">
            <p>
              We’ve sent an email to {email} with the reset password link.
              <br />
              Please check your email and follow instructions.
            </p>
          </Alert>
        )}
        <Paper>
          <FormWrapper methods={formMethods} onSubmit={onSubmit}>
            <div className="recovery__control">
              <Input
                label="Your email"
                isEmail
                type="email"
                name="email"
                required
                rules={VALID_EMAIL}
              />
              <Button loading={loading} type="submit">
                Restore!
              </Button>
            </div>
            <div className="recovery__contacts">
              <span className="password__title">Contact us</span>
              <ul className="password-list">
                <li className="password-list__item">
                  <Image src="footer-phone1.svg" alt="+44 2080 971 790" />
                  <a className="password-list__link" href="tel:+44 2080 971 790">
                    +44 2080 971 790
                  </a>
                </li>
                <li className="password-list__item">
                  <Image src="footer-phone2.svg" alt="+370 700 310 96" />
                  <a className="password-list__link" href="tel:+370 700 310 96">
                    +370 700 310 96
                  </a>
                </li>
              </ul>
              <div className="password__email">
                <span>E-mail</span>
                <a href="mailto:support@wizarbit.com">support@wizarbit.com</a>
              </div>
            </div>
          </FormWrapper>
        </Paper>
      </Container>
    </div>
  )
}
